export default "__VITE_ASSET__DX50_WqQ__"